import React, { useMemo } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";
import { Box, Typography } from "@mui/material";

type CommentTextFieldProps = {
  value: string;
  onChange: (value: string) => void;
  label?: string;
};

const CommentTextField: React.FC<CommentTextFieldProps> = ({ value, onChange, label }) => {
  const toolbarOptions = useMemo(
    () => ({
      toolbar: [
        [{ header: [1, 2, false] }],
        ["bold", "italic", "underline", "strike"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["blockquote", "code-block"],
        [{ script: "sub" }, { script: "super" }],
        [{ indent: "-1" }, { indent: "+1" }],
        [{ align: [] }],
        [{ color: [] }],
        ["clean"],
      ],
    }),
    []
  );

  return (
    <Box>
      {label && (
        <Typography variant="subtitle1" gutterBottom component="label">
          {label}
        </Typography>
      )}
      {/* <ReactQuill
        theme="snow"
        value={value}
        onChange={onChange}
        modules={toolbarOptions}
        style={{ height: "200px" }} // Adjust height for better usability
        aria-label={label || "Comment editor"}
      /> */}
    </Box>
  );
};

export default CommentTextField;
